export function backToLessonsHandlerFactory(productName, navigationEvent) {
  return () => navigationEvent(`/product/${productName}/lessons`)
}

export function unitSelectHandlerFactory(
  productName,
  navigationEvent,
  location,
) {
  return verb => (course, unitId) => {
    const searchParams = new URLSearchParams(location?.search || '')
    searchParams.delete('goToNextUnit')
    const query = searchParams.toString()
    const querySuffix = query ? `?${query}` : ''

    navigationEvent(
      `/product/${productName}/lessons/${verb}/${course}/${unitId}${querySuffix}`,
    )
  }
}
